var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from "react";
import { IllustrationProvider } from "@safetyculture/illustrations-react";
import { ModalProvider } from "../modal/modal-provider";
import { ReactDayPickerImportedGlobalStyles } from "../select/select-content/layouts/react-day-picker-imported-global-styles";
import { Skeleton } from "../skeleton";
import styled, { ThemeProvider } from "../styled";
import { ToastProvider } from "../toast/toast-provider/toast-provider";
import { configContext } from "./context";
const DefaultIllustrationWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 200px;
  width: 100%;
`;
const DefaultIllustrationLoader = styled(Skeleton) `
  aspect-ratio: 1;
  border-radius: ${(p) => p.theme._ui.radii.medium};
  width: auto;
`;
export const ConfigProvider = ({ config, children, }) => {
    const { theme, toastConfig, illustrationConfig } = config, restConfig = __rest(config, ["theme", "toastConfig", "illustrationConfig"]);
    const illustrationColorMode = (illustrationConfig === null || illustrationConfig === void 0 ? void 0 : illustrationConfig.colorMode) || (theme === null || theme === void 0 ? void 0 : theme.name) || "light";
    const illustrationLoader = useMemo(() => (illustrationConfig === null || illustrationConfig === void 0 ? void 0 : illustrationConfig.loader) || React.createElement(DefaultIllustrationLoader, null), [illustrationConfig === null || illustrationConfig === void 0 ? void 0 : illustrationConfig.loader]);
    return (React.createElement(configContext.Provider, { value: restConfig },
        React.createElement(ThemeProvider, { theme: theme },
            React.createElement(ReactDayPickerImportedGlobalStyles, null),
            React.createElement(IllustrationProvider, { colorMode: illustrationColorMode, loader: illustrationLoader, wrapper: DefaultIllustrationWrapper },
                React.createElement(ModalProvider, null,
                    React.createElement(ToastProvider, Object.assign({}, toastConfig), children))))));
};
